import { render, staticRenderFns } from "./ApplicationWelcome.vue?vue&type=template&id=1c738267&scoped=true&"
import script from "./ApplicationWelcome.vue?vue&type=script&lang=js&"
export * from "./ApplicationWelcome.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationWelcome.vue?vue&type=style&index=0&id=1c738267&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c738267",
  null
  
)

export default component.exports